import React, { FC } from 'react';
import { Breadcrumb as BreadcrumbBase } from 'antd';
import { Link } from 'react-router-dom';

type Props = {
    items: BreadcrumbItem[];
    style?: React.CSSProperties;
};

export type BreadcrumbItem = {
    url?: string;
    label: string;
    icon?: React.ReactNode;
};
//BREADCRUMB BASE COMPONENT
const Breadcrumb: FC<Props> = ({ items = [], style = {} }) => {
    return (
        <BreadcrumbBase style={style}>
            {items.map((item: BreadcrumbItem) => {
                const { label, url, icon } = item;
                return (
                    <BreadcrumbBase.Item key={label}>
                        {url ? (
                            <Link to={url}>
                                {label}
                                {icon && <span>{icon}</span>}
                            </Link>
                        ) : (
                            <>
                                {label}
                                {icon && <span>{icon}</span>}
                            </>
                        )}
                    </BreadcrumbBase.Item>
                );
            })}
        </BreadcrumbBase>
    );
};

export default Breadcrumb;
